export default __webpack_public_path__ + "static/media/WorkSans-Black.39331920.ttf";